import {Component, ViewEncapsulation} from "@angular/core";
import {SettingsService} from "../settings.service";

@Component({
    selector: 'customer-footer',
    templateUrl: './customer-footer.component.html',
    styleUrls: ['./customer-footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {'id': 'customer-footer'},
})

export class CustomerFooterComponent {

    constructor(public settings: SettingsService) {}
}



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/app/shared/customer-footer/customer-footer.component.ts